(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bd-customer-reviews')) {
    customElements.define('bd-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.cards = Array.from(this.querySelectorAll('[data-bdr-card]'));
        this.mobileQuery = window.matchMedia('(max-width:767px)');
        this.expanded = false;
        this.more = this.querySelector('[data-bdr-more]');
        this.less = this.querySelector('[data-bdr-less]');
        this.count = this.querySelector('[data-bdr-count]');
        this.heading = this.querySelector('[data-bdr-heading]');
        this.dialog = this.querySelector('[data-bdr-dialog]');
        this.stage = this.querySelector('[data-bdr-stage]');
        this.original = this.querySelector('[data-bdr-original]');
        this.loading = this.querySelector('[data-bdr-loading]');
        this.error = this.querySelector('[data-bdr-error]');
        this.hint = this.querySelector('[data-bdr-hint]');
        this.fit = this.querySelector('[data-bdr-fit]');
        this.full = this.querySelector('[data-bdr-full]');
        this.closeButton = this.querySelector('[data-bdr-close]');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.syncViewport();
        this.setAttribute('data-bdr-ready', '');
        this.mobileQuery.addEventListener('change', () => this.syncViewport(), options);
        this.more.addEventListener('click', () => {
          this.expanded = true;
          this.setCount(Math.min(this.visible + this.batch, this.cards.length));
          if (this.more.hidden) this.less.focus({ preventScroll: true });
        }, options);
        this.less.addEventListener('click', () => {
          this.expanded = false;
          this.setCount(this.initial);
          this.heading.focus({ preventScroll: true });
          this.heading.scrollIntoView({ block: 'start', behavior: 'auto' });
        }, options);
        if (typeof this.dialog.showModal === 'function') {
          this.addEventListener('click', event => {
            const link = event.target.closest('[data-bdr-open]');
            if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
            event.preventDefault();
            this.openReview(link);
          }, options);
          this.closeButton.addEventListener('click', () => this.closeReview(), options);
          this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeReview(); }, options);
          this.dialog.addEventListener('close', () => { this.restorePage(); this.syncViewport(); }, options);
          this.dialog.addEventListener('pointerdown', event => {
            this.backdropStart = this.outside(event) ? { x: event.clientX, y: event.clientY } : null;
          }, options);
          this.dialog.addEventListener('pointerup', event => {
            if (this.backdropStart && this.outside(event) && Math.hypot(event.clientX - this.backdropStart.x, event.clientY - this.backdropStart.y) < 8) this.closeReview();
            this.backdropStart = null;
          }, options);
          this.fit.addEventListener('click', () => this.setZoom(false), options);
          this.full.addEventListener('click', () => this.setZoom(true), options);
        }
        document.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
          if (index >= 0) {
            const value = Math.max(this.visible, Math.min(Math.ceil((index + 1) / this.batch) * this.batch, this.cards.length));
            this.expanded = value > this.initial;
            this.setCount(value);
          }
        }, options);
      }
      syncViewport() {
        if (!this.ready || this.dialog?.open) return;
        const active = document.activeElement;
        const mobile = this.mobileQuery.matches;
        this.initial = Math.min(Number(mobile ? this.dataset.mobileInitial : this.dataset.initial) || (mobile ? 3 : 6), this.cards.length);
        this.batch = Number(mobile ? this.dataset.mobileBatch : this.dataset.batch) || (mobile ? 3 : 6);
        this.setCount(Math.min(this.expanded ? Math.max(this.visible || 0, this.initial) : this.initial, this.cards.length));
        this.querySelector('[data-bdr-controls]').hidden = this.cards.length <= this.initial;
        const focusedCard = active?.closest?.('[data-bdr-card]');
        if ((focusedCard && this.cards.includes(focusedCard) && focusedCard.hidden) || (active === this.less && this.less.hidden) || (active === this.more && this.more.hidden)) this.heading.focus({ preventScroll: true });
      }
      setCount(value) {
        this.visible = value;
        this.cards.forEach((card, index) => {
          if (index < value) {
            const image = card.querySelector('[data-bdr-image]');
            if (image) image.replaceWith(image.content.cloneNode(true));
          }
          card.hidden = index >= value;
        });
        this.more.hidden = value >= this.cards.length;
        this.less.hidden = value <= this.initial;
        this.more.setAttribute('aria-expanded', String(value > this.initial));
        this.count.textContent = this.dataset.countLabel.replace('[shown]', String(value)).replace('[total]', String(this.cards.length));
      }
      outside(event) {
        const box = this.dialog.getBoundingClientRect();
        return event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
      }
      setZoom(full) {
        this.stage.classList.toggle('is-full', full);
        this.fit.setAttribute('aria-pressed', String(!full));
        this.full.setAttribute('aria-pressed', String(full));
        this.hint.hidden = !full;
        this.stage.scrollLeft = 0;
        this.stage.scrollTop = 0;
      }
      openReview(link) {
        if (this.dialog.open || this.pageState) return;
        const card = link.closest('[data-bdr-card]');
        const preview = card.querySelector('.bdr__preview img');
        const meta = card.querySelector('.bdr__meta p').textContent;
        const context = card.querySelector('[data-bdr-context]').content.textContent;
        this.opener = link;
        this.querySelector('[data-bdr-source]').textContent = meta;
        this.querySelector('[data-bdr-quote]').textContent = context;
        this.original.alt = preview?.alt || link.getAttribute('aria-label');
        this.original.width = Number(link.dataset.originalWidth);
        this.original.height = Number(link.dataset.originalHeight);
        this.stage.style.setProperty('--bdr-original-width', `${Number(link.dataset.originalWidth)}px`);
        this.loading.hidden = false;
        this.error.hidden = true;
        this.original.hidden = false;
        if (preview?.currentSrc) this.original.src = preview.currentSrc;
        else this.original.removeAttribute('src');
        this.setZoom(false);
        const body = document.body;
        const html = document.documentElement;
        this.pageState = { x: window.scrollX, y: window.scrollY, bodyOverflow: body.style.overflow, paddingRight: body.style.paddingRight, overflow: html.style.overflow };
        const scrollbar = window.innerWidth - html.clientWidth;
        body.style.paddingRight = `${parseFloat(getComputedStyle(body).paddingRight) + scrollbar}px`;
        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
        this.dialog.dataset.state = 'opening';
        try { this.dialog.showModal(); } catch (_) { this.restorePage(); window.open(link.href, '_blank', 'noopener'); return; }
        this.closeButton.focus({ preventScroll: true });
        const token = this.token = (this.token || 0) + 1;
        requestAnimationFrame(() => requestAnimationFrame(() => { if (this.dialog.open && this.token === token && this.dialog.dataset.state !== 'closing') this.dialog.dataset.state = 'open'; }));
        const image = this.pendingImage = new Image();
        image.onload = async () => {
          try { await image.decode(); } catch (_) {}
          if (this.token !== token || !this.dialog.open || this.dialog.dataset.state === 'closing') return;
          this.original.src = image.src;
          this.loading.hidden = true;
        };
        image.onerror = () => {
          if (this.token !== token || !this.dialog.open) return;
          this.loading.hidden = true;
          this.error.hidden = false;
          if (!preview?.naturalWidth) this.original.hidden = true;
        };
        image.src = link.href;
      }
      closeReview(immediate = false) {
        if (!this.dialog?.open) return;
        if (this.dialog.dataset.state === 'closing' && !immediate) return;
        this.token = (this.token || 0) + 1;
        this.dialog.dataset.state = 'closing';
        clearTimeout(this.closeTimer);
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (immediate || reduced) this.dialog.close();
        else this.closeTimer = setTimeout(() => this.dialog.close(), 170);
      }
      restorePage() {
        clearTimeout(this.closeTimer);
        if (this.pendingImage) { this.pendingImage.onload = null; this.pendingImage.onerror = null; this.pendingImage = null; }
        if (!this.pageState) return;
        const state = this.pageState;
        this.pageState = null;
        Object.assign(document.body.style, { overflow: state.bodyOverflow, paddingRight: state.paddingRight });
        document.documentElement.style.overflow = state.overflow;
        window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
        const target = this.opener?.isConnected ? this.opener : this.heading;
        if (target?.isConnected) target.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.token = (this.token || 0) + 1;
        this.closeReview(true);
        this.restorePage();
        this.abort?.abort();
        this.removeAttribute('data-bdr-ready');
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moka-best-seller"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moka-best-seller')) {
    customElements.define('moka-best-seller', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.rail = this.querySelector('[data-product-rail]');
        this.previous = this.querySelector('[data-rail-previous]');
        this.next = this.querySelector('[data-rail-next]');
        this.progress = this.querySelector('[data-rail-progress]');
        this.thumb = this.querySelector('[data-rail-progress-thumb]');
        if (!this.rail || !this.previous || !this.next || !this.progress || !this.thumb) return;

        this.update = () => {
          const max = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
          const position = max > 0 ? Math.min(1, Math.max(0, this.rail.scrollLeft / max)) : 0;
          const visibleRatio = Math.min(1, this.rail.clientWidth / Math.max(this.rail.scrollWidth, 1));
          const progressWidth = this.progress.clientWidth;
          const thumbWidth = Math.max(28, progressWidth * visibleRatio);
          this.thumb.style.width = thumbWidth + 'px';
          this.thumb.style.transform = 'translateX(' + ((progressWidth - thumbWidth) * position) + 'px)';
          this.progress.setAttribute('aria-valuenow', String(Math.round(position * 100)));
          this.previous.disabled = this.rail.scrollLeft <= 2;
          this.next.disabled = this.rail.scrollLeft >= max - 2;
        };

        this.move = (direction) => {
          const card = this.querySelector('[data-product-card]');
          if (!card) return;
          const track = this.querySelector('.moka-best-seller__track');
          const gap = track ? parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) : 0;
          this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        };

        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.rail.addEventListener('scroll', () => requestAnimationFrame(this.update), { passive: true });
        this.rail.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(-1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(1);
          }
        });

        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-product-card]');
          if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });

        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.rail);
        requestAnimationFrame(this.update);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moka-case-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('[data-moka-cases]').forEach((section) => {
        if (section.dataset.mokaCasePreloadReady) return;
        section.dataset.mokaCasePreloadReady = 'pending';

        const images = Array.from(section.querySelectorAll('.moka-case-image'));
        const warm = (image) => new Promise((resolve) => {
          const finish = () => {
            const decoded = typeof image.decode === 'function'
              ? image.decode().then(() => true).catch(() => false)
              : Promise.resolve(true);
            decoded.then((isDecoded) => resolve(isDecoded && image.complete && image.naturalWidth > 0));
          };

          image.addEventListener('load', finish, { once: true });
          image.addEventListener('error', () => resolve(false), { once: true });
          image.loading = 'eager';
          if (image.complete) finish();
        });

        const start = () => {
          Promise.all(images.map(warm)).then((results) => {
            section.dataset.mokaCasePreloadReady = results.length === 5 && results.every(Boolean) ? 'true' : 'error';
          });
        };

        const schedule = () => {
          if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2000 });
          else window.setTimeout(start, 0);
        };

        if (document.readyState === 'complete') schedule();
        else window.addEventListener('load', schedule, { once: true });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moka-contact-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const populateInquiryContext = () => {
      const form = document.querySelector('#MokaContactPageForm');
      if (!form || form.dataset.mokaContextReady) return;
      form.dataset.mokaContextReady = 'true';

      const message = form.querySelector('[data-bd-inquiry-message]');
      const body = form.querySelector('[data-bd-inquiry-body]');
      if (!message || !body) return;

      const storageKey = 'bd-inquiry/v1:' + form.id + ':' + window.location.pathname;
      const read = (key) => {
        try { return window.sessionStorage.getItem(key) || ''; } catch (error) { return ''; }
      };
      const write = (key, value) => {
        try { window.sessionStorage.setItem(key, value); } catch (error) {}
      };
      const remove = (key) => {
        try { window.sessionStorage.removeItem(key); } catch (error) {}
      };
      const normalizeMeta = (value) => String(value || '').replace(/\r\n?|\n/g, ' ').replace(/[\u0000-\u001F\u007F]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 2048);
      const normalizeMessage = (value) => String(value || '').replace(/\r\n?/g, '\n').trim();
      const language = () => {
        const value = normalizeMeta(document.documentElement.lang).replace(/_/g, '-');
        return /^[A-Za-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/.test(value) ? value : 'en';
      };
      const createUuid = () => {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID().toLowerCase();
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 15) | 64;
        bytes[8] = (bytes[8] & 63) | 128;
        return Array.from(bytes, (byte, index) => [4, 6, 8, 10].includes(index) ? '-' + byte.toString(16).padStart(2, '0') : byte.toString(16).padStart(2, '0')).join('');
      };
      const identifier = () => {
        const existing = read(storageKey + ':submission_id');
        if (/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(existing)) return existing.toLowerCase();
        const value = createUuid();
        write(storageKey + ':submission_id', value);
        return value;
      };
      const buildBody = () => {
        const meta = {
          version: 'bd-inquiry/1',
          submission_id: identifier(),
          product: '',
          model: '',
          source_page: window.location.origin + window.location.pathname,
          page_language: language()
        };
        return ['[BD_INQUIRY_BEGIN]', JSON.stringify(meta), '[BD_MESSAGE_BEGIN]', normalizeMessage(message.value), '[BD_MESSAGE_END]', '[BD_INQUIRY_END]'].join('\n');
      };
      const prepare = (event) => {
        const payload = buildBody();
        body.value = payload;
        if (event) event.formData.set('contact[body]', payload);
      };

      const params = new URLSearchParams(window.location.search);
      const clean = (value) => normalizeMeta(value).slice(0, 500);
      const source = params.get('source') === 'product' ? 'product' : '';
      const product = source ? clean(params.get('product')) : '';
      const modelValue = clean(params.get('model'));
      const model = source && modelValue !== 'Default Title' ? modelValue : '';
      const panel = form.querySelector('[data-moka-inquiry-context]');
      const fields = {Source: source, Product: product, Model: model};
      Object.entries(fields).forEach(([key, value]) => {
        const input = form.elements.namedItem('contact[' + key + ']');
        if (input) { input.value = value; input.defaultValue = value; }
      });
      if (panel && source && product) {
        panel.hidden = params.get('show_context') === '0';
        panel.querySelector('[data-moka-inquiry-summary]').textContent = panel.dataset.productLabel + ': ' + product + '\n' + panel.dataset.modelLabel + ': ' + (model || panel.dataset.pendingLabel);
      }

      const success = form.querySelector('[data-moka-form-success]');
      const errors = form.querySelector('[data-moka-form-errors]');
      if (success && success.dataset.postedSuccessfully === 'true') {
        remove(storageKey + ':submission_id');
        remove(storageKey + ':message');
      } else if (errors && errors.dataset.hasErrors === 'true') {
        const savedMessage = read(storageKey + ':message');
        if (savedMessage) message.value = savedMessage;
      }
      form.addEventListener('submit', () => {
        write(storageKey + ':message', message.value);
        prepare();
      });
      form.addEventListener('formdata', prepare);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', populateInquiryContext, {once: true});
    else populateInquiryContext();
    document.addEventListener('shopify:section:load', populateInquiryContext);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moka-email-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popupSelector = '[data-moka-email-popup]';
    const sessionDismissedKey = 'moka-email-popup-dismissed';
    const subscribedKey = 'moka-email-popup-subscribed';
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const storageGet = (storage, key) => {
      try {
        return storage.getItem(key);
      } catch (error) {
        return null;
      }
    };

    const storageSet = (storage, key, value) => {
      try {
        storage.setItem(key, value);
      } catch (error) {}
    };

    const isDesignMode = () => Boolean(window.Shopify && window.Shopify.designMode);

    const isEligible = (popup) => {
      if (isDesignMode()) return true;
      if (popup.dataset.mokaPopupState === 'subscribed') return false;
      if (storageGet(window.localStorage, subscribedKey) === 'true') return false;
      return storageGet(window.sessionStorage, sessionDismissedKey) !== 'true';
    };

    const getFocusableElements = (popup) => Array.from(popup.querySelectorAll(focusableSelector))
      .filter((element) => !element.hidden && element.getClientRects().length > 0);

    const showPopup = (popup) => {
      if (!isEligible(popup)) return;
      window.clearTimeout(popup.mokaShowTimer);
      popup.mokaReturnFocus = document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;
      popup.hidden = false;
      popup.classList.remove('is-closing');
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          popup.classList.add('is-visible');
          window.requestAnimationFrame(() => {
            const focusTarget = getFocusableElements(popup)[0] || popup;
            focusTarget.focus({ preventScroll: true });
          });
        });
      });
    };

    const hidePopup = (popup, rememberDismissal = true) => {
      window.clearTimeout(popup.mokaShowTimer);
      if (rememberDismissal && !isDesignMode()) {
        storageSet(window.sessionStorage, sessionDismissedKey, 'true');
      }
      popup.classList.remove('is-visible');
      popup.classList.add('is-closing');
      window.setTimeout(() => {
        popup.hidden = true;
        popup.classList.remove('is-closing');
        const returnFocus = popup.mokaReturnFocus;
        popup.mokaReturnFocus = null;
        if (returnFocus && returnFocus.isConnected) {
          returnFocus.focus({ preventScroll: true });
        }
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 380);
    };

    const setFeedback = (feedback, message, isHtml = false) => {
      if (!feedback) return;
      if (isHtml) feedback.innerHTML = message;
      else feedback.textContent = message;
      feedback.hidden = !message;
      if (message) feedback.focus({ preventScroll: true });
    };

    const initPopup = (popup) => {
      if (popup.dataset.mokaPopupReady === 'true') return;
      popup.dataset.mokaPopupReady = 'true';

      const closeButton = popup.querySelector('[data-moka-email-popup-close]');
      const form = popup.querySelector('form');
      const feedback = popup.querySelector('[data-moka-email-popup-feedback]');
      const success = popup.querySelector('[data-moka-email-popup-success]');
      const serverSuccess = popup.querySelector('[data-moka-email-popup-server-success]');
      const submitButton = form && form.querySelector('button[type="submit"]');
      const submitLabel = submitButton && submitButton.querySelector('span');
      const designMode = isDesignMode();

      if (serverSuccess && !designMode) {
        storageSet(window.localStorage, subscribedKey, 'true');
      }

      if (!designMode) {
        if (storageGet(window.localStorage, subscribedKey) === 'true') return;
        if (storageGet(window.sessionStorage, sessionDismissedKey) === 'true') return;
      }

      const delay = designMode ? 600 : Math.max(Number(popup.dataset.delaySeconds) || 15, 0) * 1000;
      popup.mokaShowTimer = window.setTimeout(() => showPopup(popup), delay);

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          hidePopup(popup, true);
        });
      }

      popup.addEventListener('click', (event) => {
        if (event.target === popup) hidePopup(popup, true);
      });

      popup.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
          event.preventDefault();
          hidePopup(popup, true);
          return;
        }

        if (event.key === 'Tab' && popup.classList.contains('is-visible')) {
          const focusable = getFocusableElements(popup);
          if (!focusable.length) {
            event.preventDefault();
            popup.focus({ preventScroll: true });
            return;
          }
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });

      if (!form) return;

      form.addEventListener('submit', async (event) => {
        if (!form.checkValidity()) return;
        event.preventDefault();
        if (form.dataset.mokaSubmitting === 'true') return;

        form.dataset.mokaSubmitting = 'true';
        form.setAttribute('aria-busy', 'true');
        setFeedback(feedback, '');
        if (submitButton) submitButton.disabled = true;
        if (submitLabel && submitButton) submitLabel.textContent = submitButton.dataset.sendingLabel;

        try {
          const response = await fetch(form.action, {
            method: (form.method || 'post').toUpperCase(),
            body: new FormData(form),
            credentials: 'same-origin',
            redirect: 'follow',
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
          });
          const responseHtml = await response.text();
          const responseDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
          const challengeRequired = /\/challenge(?:[/?#]|$)/i.test(response.url || '') || Boolean(
            responseDocument.querySelector('.shopify-challenge__container, iframe[src*="hcaptcha"], iframe[src*="recaptcha"]')
          );

          if (challengeRequired) {
            throw new Error('verification');
          }

          const returnedForm = responseDocument.getElementById(form.id);
          const returnedSuccess = returnedForm && returnedForm.querySelector('[data-moka-email-popup-server-success]');
          const returnedErrors = returnedForm && returnedForm.querySelector('[data-moka-email-popup-server-errors]');
          const urlShowsSuccess = /[?&]customer_posted=true(?:[&#]|$)/i.test(response.url || '');

          if (response.ok && (urlShowsSuccess || returnedSuccess)) {
            popup.dataset.mokaPopupState = 'subscribed';
            storageSet(window.localStorage, subscribedKey, 'true');
            form.reset();
            form.hidden = true;
            if (success) {
              success.hidden = false;
              success.focus({ preventScroll: true });
            }
            window.setTimeout(() => hidePopup(popup, false), 4600);
            return;
          }

          if (returnedErrors) {
            setFeedback(feedback, returnedErrors.innerHTML, true);
            return;
          }

          throw new Error('network');
        } catch (error) {
          const message = error && error.message === 'verification'
            ? popup.dataset.verificationError
            : popup.dataset.networkError;
          setFeedback(feedback, message);
        } finally {
          form.dataset.mokaSubmitting = 'false';
          form.setAttribute('aria-busy', 'false');
          if (submitButton) submitButton.disabled = false;
          if (submitLabel && submitButton) submitLabel.textContent = submitButton.dataset.label;
        }
      });
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches(popupSelector)) initPopup(scope);
      scope.querySelectorAll(popupSelector).forEach(initPopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const popup = event.target.matches && event.target.matches(popupSelector)
        ? event.target
        : event.target.querySelector(popupSelector);
      if (popup) showPopup(popup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moka-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindFooter = (footer) => {
      if (!footer || footer.dataset.mokaFooterReady === 'true') return;
      footer.dataset.mokaFooterReady = 'true';

      const backToTop = footer.querySelector('[data-moka-back-to-top]');
      if (backToTop) {
        backToTop.addEventListener('click', () => {
          window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      }

      const privacyButton = footer.querySelector('[data-moka-privacy-preferences]');
      if (!privacyButton) return;

      const resolvePrivacyAction = () => {
        const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!customerPrivacy) return null;
        if (typeof customerPrivacy.showPreferences === 'function') return customerPrivacy.showPreferences.bind(customerPrivacy);
        if (typeof customerPrivacy.openPreferences === 'function') return customerPrivacy.openPreferences.bind(customerPrivacy);
        return null;
      };

      const enablePrivacyButton = () => {
        const action = resolvePrivacyAction();
        if (!action) return false;
        privacyButton.hidden = false;
        privacyButton.onclick = action;
        return true;
      };

      if (!enablePrivacyButton()) {
        [250, 1000, 2500].forEach((delay) => window.setTimeout(enablePrivacyButton, delay));
      }
    };

    document.querySelectorAll('.moka-footer').forEach(bindFooter);
    document.addEventListener('shopify:section:load', (event) => {
      bindFooter(event.target.querySelector('.moka-footer'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moka-header"]) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const initHeader = (header) => {
    if (instances.has(header)) return;
    const inner = header.querySelector('.moka-header__inner');
    const logo = header.querySelector('.moka-header__logo');
    const nav = header.querySelector('.moka-nav');
    const tools = header.querySelector('.moka-header__tools');
    const toggle = header.querySelector('[data-moka-mobile-toggle]');
    const drawer = header.querySelector('.moka-mobile-drawer');
    if (!inner || !logo || !nav || !tools) return;
    let frame = 0;
    let destroyed = false;
    const width = (element) => element.getBoundingClientRect().width;
    const fit = () => {
      frame = 0;
      if (destroyed || !header.isConnected) return;
      const available = width(inner);
      if (!available) return;
      const previous = header.dataset.mokaLayout;
      delete header.dataset.mokaToolsDrawer;
      header.dataset.mokaLayout = 'measure';
      const gap = parseFloat(getComputedStyle(inner).columnGap) || 0;
      const logoWidth = width(logo);
      const navWidth = width(nav);
      const toolsWidth = width(tools);
      const single = logoWidth + navWidth + toolsWidth + gap * 2 + 2;
      const mode = available >= single ? 'single' : 'compact';
      header.dataset.mokaLayout = mode;
      delete header.dataset.mokaToolsDrawer;
      if (mode === 'compact' && logoWidth + width(tools) + gap + 2 > available) {
        const controls = [...tools.children].filter((element) => !element.matches('.moka-mobile-toggle,.moka-header__icon,.moka-btn,[hidden]'));
        const height = Math.max(0, ...controls.map((element) => element.getBoundingClientRect().height));
        header.style.setProperty('--moka-drawer-tools-height', `${height + 16}px`);
        header.dataset.mokaToolsDrawer = 'true';
      }
      if (mode !== 'compact' && drawer && toggle) {
        drawer.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
      if (mode === 'compact' && previous !== mode && nav.contains(document.activeElement) && toggle) toggle.focus();
    };
    const schedule = () => {
      if (!frame && !destroyed) frame = requestAnimationFrame(fit);
    };
    const observed = new WeakSet();
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    const watch = () => {
      if (!resize) return;
      [inner, logo, nav, tools, ...tools.children, ...nav.children].forEach((element) => {
        if (!observed.has(element)) {
          resize.observe(element);
          observed.add(element);
        }
      });
    };
    const mutation = new MutationObserver(() => { watch(); schedule(); });
    mutation.observe(tools, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    mutation.observe(nav, { subtree: true, childList: true, characterData: true });
    mutation.observe(logo, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset', 'class', 'style'] });
    window.addEventListener('resize', schedule, { passive: true });
    header.addEventListener('load', schedule, true);
    if (document.fonts) {
      document.fonts.ready.then(schedule);
      document.fonts.addEventListener('loadingdone', schedule);
    }
    instances.set(header, () => {
      destroyed = true;
      cancelAnimationFrame(frame);
      if (resize) resize.disconnect();
      mutation.disconnect();
      window.removeEventListener('resize', schedule);
      header.removeEventListener('load', schedule, true);
      if (document.fonts) document.fonts.removeEventListener('loadingdone', schedule);
      instances.delete(header);
    });
    watch();
    fit();
  };
  const init = (scope) => {
    if (scope.matches && scope.matches('.moka-header')) initHeader(scope);
    scope.querySelectorAll('.moka-header').forEach(initHeader);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.moka-header').forEach((header) => instances.get(header)?.());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moka-partners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bd-partner-network')) {
    customElements.define('bd-partner-network', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.bd-partners__list');
        this.controls = this.querySelector('.bd-partners__controls');
        this.prev = this.querySelector('[data-bd-prev]');
        this.next = this.querySelector('[data-bd-next]');
        this.range = this.querySelector('[data-bd-range]');
        if (!this.list || !this.controls) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.prev.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.list.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.list.addEventListener('keydown', event => {
          if (event.target !== this.list || this.controls.hidden) return;
          const rtl = getComputedStyle(this.list).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.list.scrollTo({ left: event.key === 'Home' ? 0 : (rtl ? -1 : 1) * this.list.scrollWidth, behavior: 'instant' });
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.bd-partners__item');
          if (!card || this.controls.hidden) return;
          const rail = this.list.getBoundingClientRect();
          const rect = card.getBoundingClientRect();
          if (rect.left < rail.left || rect.right > rail.right) this.list.scrollBy({ left: rect.left - rail.left, behavior: 'instant' });
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.list);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      move(direction) {
        const first = this.list.firstElementChild;
        if (!first) return;
        const style = getComputedStyle(this.list);
        const step = first.getBoundingClientRect().width + parseFloat(style.columnGap);
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.list.scrollBy({ left: direction * (style.direction === 'rtl' ? -1 : 1) * step, behavior: reduced ? 'instant' : 'smooth' });
      }
      update() {
        const cards = Array.from(this.list.children);
        const overflow = this.list.scrollWidth > this.list.clientWidth + 2;
        this.controls.hidden = !overflow;
        this.list.tabIndex = overflow ? 0 : -1;
        if (!overflow || !cards.length) return;
        const viewport = this.list.getBoundingClientRect();
        const indices = cards.map((card, index) => {
          const rect = card.getBoundingClientRect();
          return rect.left >= viewport.left - 2 && rect.right <= viewport.right + 2 ? index + 1 : null;
        }).filter(value => value !== null);
        if (indices.length) {
          const text = this.range.dataset.format.replace('__FIRST__', Math.min(...indices)).replace('__LAST__', Math.max(...indices)).replace('__TOTAL__', cards.length);
          if (this.range.textContent !== text) this.range.textContent = text;
        }
        const offset = Math.abs(this.list.scrollLeft);
        this.prev.disabled = offset < 2;
        this.next.disabled = offset >= this.list.scrollWidth - this.list.clientWidth - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moka-product-specifications"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wrapComparisonTable = () => {
      const root = document.querySelector('[data-moka-lf80-specs]');
      if (!root) return;
      document.documentElement.classList.add('moka-lf80-series');
      document.querySelectorAll('.product__description table').forEach((table) => {
        if (table.parentElement?.classList.contains('moka-lf80-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'moka-lf80-table-scroll';
        wrapper.tabIndex = 0;
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    };

    const initLf80Series = () => {
      wrapComparisonTable();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLf80Series, { once: true });
    } else {
      initLf80Series();
    }

    document.addEventListener('shopify:section:load', initLf80Series);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moka-whats-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moka-whats-new')) {
    customElements.define('moka-whats-new', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.rail = this.querySelector('[data-product-rail]');
        this.previous = this.querySelector('[data-rail-previous]');
        this.next = this.querySelector('[data-rail-next]');
        if (!this.rail || !this.previous || !this.next) return;

        this.update = () => {
          const max = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
          this.previous.disabled = this.rail.scrollLeft <= 2;
          this.next.disabled = this.rail.scrollLeft >= max - 2;
          this.classList.toggle('is-static', max <= 2);
        };

        this.move = (direction) => {
          const card = this.querySelector('[data-product-card]');
          if (!card) return;
          const track = this.querySelector('.moka-product-rail__track');
          const gap = track ? parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) : 0;
          this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        };

        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.rail.addEventListener('scroll', () => requestAnimationFrame(this.update), { passive: true });
        this.rail.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(-1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(1);
          }
        });

        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-product-card]');
          if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });

        this.updateCardSize = () => {
          if (!window.matchMedia('(min-width: 990px)').matches) {
            this.style.removeProperty('--moka-card-size-ratio');
            return;
          }
          const card = this.querySelector('[data-product-card]');
          const track = this.querySelector('.moka-product-rail__track');
          if (!card || !track) return;
          const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
          const originalWidth = (this.rail.clientWidth - 3 * gap) / 3.18;
          if (originalWidth <= 0) return;
          const ratio = card.getBoundingClientRect().width / originalWidth;
          const value = ratio.toFixed(6);
          if (this.style.getPropertyValue('--moka-card-size-ratio') !== value) this.style.setProperty('--moka-card-size-ratio', value);
        };
        this.resizeObserver = new ResizeObserver(() => {
          this.updateCardSize();
          this.update();
        });
        this.resizeObserver.observe(this.rail);
        this.updateCardSize();
        requestAnimationFrame(this.update);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
